import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBz2ecD_RNdFtPG4Z_8Utn9E56y_qMsi3o",
  authDomain: "elephant-please.firebaseapp.com",
  projectId: "elephant-please",
  storageBucket: "elephant-please.appspot.com",
  messagingSenderId: "329599777857",
  appId: "1:329599777857:web:362c612ee3ddedc6d9dac0",
  measurementId: "G-PP2QW6TPL2",
};

// Initialize Firebase
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

// Initialize Cloud Firestore and get a reference to the service
const db = firebase.firestore();

//add data to db
export const SaveUniqueData = ({collectionName, id, userData}) => {
  return db.collection(collectionName).doc(`${id}`).set(userData, { merge: true });
};

export const FindRoom = ({collectionName, ids}) => {
  // ids.forEach(id => check = check.where(`${id}`, "==" , true));
 return db.collection(collectionName).where(`${ids[0]}`, "==" , true)
 .where(`${ids[1]}`, "==" , true).get()
};

export const CreateRoom = ({collectionName, payload}) => {
  return db.collection(collectionName).add(payload)
};

export const FindMyRoom = ({collectionName, id}, handleRealTime) => {
 return db.collection(collectionName).where(`${id}`, "==" , true).onSnapshot(handleRealTime)
};

export const GetMessages = ({collectionName, id}, handleRealTime) => {
  return db.collection(collectionName).where('id', '==', id).onSnapshot(handleRealTime)
 };

 export const FindById = ({collectionName, id}) => {
 return db.collection(collectionName).where('id', '==', id).get()
};

export const updateData = ({ collectionName, id, payload }) => {
  return db.collection(collectionName).doc(`${id}`).update(payload);
};


// import firebase from "firebase/compat/app";
// //
// // import "firebase/auth";
// // import "firebase/firestore";
// import "firebase/database";
// // import "firebase/storage";
// import { getDatabase, ref, get, child, set } from "firebase/database";

// // import { getDatabase, ref, set } from "firebase/database";

// const firebaseConfig = {
//   apiKey: "AIzaSyBz2ecD_RNdFtPG4Z_8Utn9E56y_qMsi3o",
//   authDomain: "elephant-please.firebaseapp.com",
//   projectId: "elephant-please",
//   storageBucket: "elephant-please.appspot.com",
//   messagingSenderId: "329599777857",
//   appId: "1:329599777857:web:362c612ee3ddedc6d9dac0",
//   measurementId: "G-PP2QW6TPL2",
// };

// const dbRef = ref(getDatabase());

// if (!firebase.apps.length) {
// firebase.initializeApp(firebaseConfig);
// }

// // const db = firebase.firestore();
// // const auth = firebase.auth();
// // const storageRef = firebase.storage().ref();

// async function writeUserData(data) {
//   let payload = {
//     firstname: data.firstname,
//     lastname: data.lastname,
//     email: data.email,
//     // profile_picture: `${imageUrl}${data.profileImagePath}`,
//   };
//   try {
//     let res = await ref("users/").set(payload);
//     console.log(res, "'resresresresresresresres");
//   } catch (error) {
//     console.log("ssssssssss ~ error", error);
//   }
// }

// // const createRes = (id, collectionName, payload) => {
// //   return db.collection(collectionName).doc(id).set(payload);
// // };

// // const crerateNestedResource = ({
// //   docId,
// //   collectionName,
// //   subCollection,
// //   payload,
// //   subDocId,
// // }) => {
// //   return db
// //     .collection(collectionName)
// //     .doc(docId)
// //     .collection(subCollection)
// //     .doc(subDocId)
// //     .set(payload);
// // };

// // const createResWithRefrence = ({ collectionName, payload, refrence }) => {
// //   return db.collection(collectionName).add({
// //     quotesId: db.doc(`${refrence}/${payload.categoryId}`),
// //   });
// // };

// // const innerCollectionRefrence = async ({
// //   parentCollection,
// //   childCollection,
// //   arrInfo,
// // }) => {
// //   try {
// //     let allPromise = arrInfo.map(
// //       async (item) =>
// //         await firebase
// //           .firestore()
// //           .collection(parentCollection)
// //           .doc(item.id)
// //           .collection(childCollection)
// //           .get()
// //     );

// //     const res = await Promise.all(allPromise);
// //     const myRealData = [];
// //     res.forEach((singleCollection, index) => {
// //       singleCollection.forEach((collectionDoc) => {
// //         const subCategory = {
// //           id: collectionDoc.id,
// //           ...collectionDoc.data(),
// //         };

// //         const mergeCatAndSubCat = {
// //           subCategory,
// //           ...arrInfo[index].data,
// //           id: arrInfo[index].id,
// //         };
// //         myRealData.push(mergeCatAndSubCat);
// //       });
// //     });

// //     return myRealData;
// //   } catch (error) {
// //     return error;
// //   }
// //   // });
// //   // try {
// //   //   let data = [];
// //   //   Promise.all(arrInfo).then((res) => {
// //   //     return res.map(async (item) => {
// //   //       let snapshot = await firebase
// //   //         .firestore()
// //   //         .collection(parentCollection)
// //   //         .doc(item.id)
// //   //         .collection(childCollection)
// //   //         .get();

// //   //        snapshot.forEach((doc) => {
// //   //         data.push({ subcategory: doc.data(), category: item });
// //   //       });
// //   //     });
// //   //   });
// //   //   console.log("::", data, "ddddddd");
// //   //   // arrInfo.forEach(async (item) => {
// //   //   //   let snapshot = await firebase
// //   //   //     .firestore()
// //   //   //     .collection(parentCollection)
// //   //   //     .doc(item.id)
// //   //   //     .collection(childCollection)
// //   //   //     .get();

// //   //   //   snapshot.forEach((doc) => {
// //   //   //     data.push({ subcategory: doc.data(), category: item });
// //   //   //   });
// //   //   // });
// //   // } catch (err) {
// //   //   console.log("errrr", err);
// //   // }
// // };

// // const getNestedCollectionWithRef = async ({
// //   parentCollection,
// //   childCollection,
// // }) => {
// //   return new Promise(async (resolve, reject) => {
// //     let arrInfo = [];
// //     try {
// //       let eventProducerRef = await db.collection(parentCollection);
// //       let producer = await eventProducerRef.get();

// //       producer.forEach(async (snapshot) => {
// //         arrInfo.push({ id: snapshot.id, data: snapshot.data() });
// //       });

// //       // GET DATA FROM ANOHTER COLLECTION WITH NESTED
// //       innerCollectionRefrence({
// //         parentCollection,
// //         childCollection,
// //         arrInfo,
// //       })
// //         .then((response) => {
// //           resolve(response);
// //         })
// //         .catch((error) => {
// //           reject(error);
// //         });
// //     } catch (error) {
// //       reject(error);
// //     }
// //   });
// // };

// // const getWithRefrence = (collectionName, payload) => {
// //   return new Promise((resolve, reject) => {
// //     db.collection(collectionName)
// //       .where(payload.categoryId, "==", payload.id)
// //       .get()
// //       .then((snapshot) => {
// //         snapshot.forEach((doc) => {
// //           resolve(doc.data());
// //         });
// //       })
// //       .catch(function (error) {
// //         reject(error);
// //       });
// //   });
// // };

// // const generateUserDocument = async ({
// //   collectionName,
// //   user,
// //   additionalData,
// // }) => {
// //   if (!user) return;
// //   const userRef = firebase.firestore().doc(`${collectionName}/${user.uid}`);
// //   const snapshot = await userRef.get();

// //   console.log("snapshot", snapshot);
// //   //   if (!snapshot.exists) {
// //   //     const { email, displayName, photoURL } = user;
// //   //     try {
// //   //       await userRef.set({
// //   //         displayName,
// //   //         email,
// //   //         photoURL,
// //   //         ...additionalData,
// //   //       });
// //   //     } catch (error) {
// //   //       console.error("Error creating user document", error);
// //   //     }
// //   //   }
// //   //   return getUserDocument(user.uid);
// // };

// // const userRegistration = (payload, props) => {
// //   return new Promise(async (resolve, reject) => {
// //     firebase
// //       .auth()
// //       .createUserWithEmailAndPassword(payload.email, payload.password)
// //       .then((userCredential) => {
// //         delete payload["password"];
// //         createRes("user", payload);
// //         // SuccessHelper.handleSuccess("Register", true);
// //         var user = userCredential.user;
// //       })
// //       .catch((error) => {
// //         // ErrorHelper.handleErrors(error.message, true);
// //       });
// //   });
// // };

// // const userLogin = (payload, props) => {
// //   return new Promise(async (resolve, reject) => {
// //     firebase
// //       .auth()
// //       .signInWithEmailAndPassword(payload.email, payload.password)
// //       .then((userCredential) => {
// //         db.collection(`user`)
// //           .get()
// //           .then((querySnapshot) => {
// //             querySnapshot.forEach((doc) => {
// //               if (payload.email == doc.data().email) {
// //                 let item = {
// //                   id: doc.id,
// //                   data: doc.data(),
// //                 };

// //                 if (doc.data()?.userType !== "admin") {
// //                   // ErrorHelper.handleErrors("User type does not match", true);
// //                   reject(false);
// //                 } else if (!doc.data()?.isActive) {
// //                   // ErrorHelper.handleErrors(
// //                   //   "You account was deleted by admin!",
// //                   //   true
// //                   // );
// //                   reject(false);
// //                 } else {
// //                   sessionStorage.setItem("user", JSON.stringify(item));
// //                   props.history.push("/users");
// //                   resolve(true);
// //                   // SuccessHelper.handleSuccess("Login Successfully", true);
// //                 }
// //               }
// //             });
// //           })
// //           .catch((err) => {
// //             console.log("sererer", err);
// //           });
// //       })
// //       .catch((error) => {
// //         reject(false);
// //         // ErrorHelper.handleErrors(error.message, true);
// //       });
// //   });
// // };

// // const userLogout = () => {
// //   return firebase.auth().signOut();
// // };

// // const getResource = async ({ collectionName, userType, isUser }) => {
// //   try {
// //     const snapshot = await firebase
// //       .firestore()
// //       .collection(collectionName)
// //       .orderBy("timeStamp")
// //       .get();
// //     const collection = [];
// //     snapshot.forEach((doc) => {
// //       if (isUser) {
// //         if (doc.data().userType == userType && doc.data().isActive) {
// //           let data = {
// //             info: doc.data(),
// //           };
// //           data.info.id = doc.id;
// //           collection.push(data);
// //         }
// //       } else {
// //         let data = {
// //           info: doc.data(),
// //         };

// //         data.info.id = doc.id;
// //         collection.push(data);
// //       }
// //     });
// //     return collection;
// //   } catch (error) {
// //     return error;
// //   }
// // };

// // const getResourceFromIds = async ({
// //   collectionName,
// //   collectionId,
// //   subCollection,
// //   subCollectionId,
// // }) => {
// //   try {
// //     const snapshot = await firebase
// //       .firestore()
// //       .collection(collectionName)
// //       .doc(collectionId)
// //       .collection(subCollection)
// //       .doc(subCollectionId)
// //       .get();

// //     let data = {
// //       info: snapshot.data(),
// //     };
// //     data.info.id = snapshot.id;

// //     return data;
// //   } catch (error) {
// //     return error;
// //   }
// // };

// // const uploadImage = async (id, image, collectionName) => {
// //   return new Promise(async (resolve, reject) => {
// //     try {
// //       firebase
// //         .storage()
// //         .ref(`/images/${id}`)
// //         .put(image)
// //         .then((snapshot) => {
// //           firebase
// //             .storage()
// //             .ref(`/images/${id}`)
// //             .getDownloadURL()
// //             .then(function (url) {
// //               resolve(url);
// //             })
// //             .catch((error) => {
// //               reject(error);
// //             });
// //         });
// //     } catch (error) {
// //       reject(error);
// //     }
// //   });
// // };

// // const updateNestedData = ({
// //   parentCollection,
// //   childCollection,
// //   parentDoc,
// //   childDoc,
// //   payload,
// // }) => {
// //   return db
// //     .collection(parentCollection)
// //     .doc(parentDoc)
// //     .collection(childCollection)
// //     .doc(childDoc)
// //     .update(payload);
// // };

// // const deleteNestedData = ({
// //   parentCollection,
// //   childCollection,
// //   parentDoc,
// //   childDoc,
// // }) => {
// //   return db
// //     .collection(parentCollection)
// //     .doc(parentDoc)
// //     .collection(childCollection)
// //     .doc(childDoc)
// //     .delete();
// // };

// // const updateData = ({ collectionName, id, payload }) => {
// //   return db.collection(collectionName).doc(id).update(payload);
// // };

// // const removeData = ({ collectionName, id }) => {
// //   return db.collection(collectionName).doc(id).delete();
// // };

// // const removeFiles = (id) => {
// //   return firebase.storage().ref(`/images/${id}`).delete();
// // };

// // const collectionGroupQuery = ({ collectionName, queryKey, queryValue }) => {
// //   return db
// //     .collectionGroup(collectionName)
// //     .where(queryKey, "==", queryValue)
// //     .get();
// //   // museums.get().then((querySnapshot) => {
// //   //   querySnapshot.forEach((doc) => {
// //   //     console.log(doc.id, " => ", doc.data());
// //   //   });
// //   // });
// // };

// // const deleteResourceFromNestedSubCollection = ({
// //   collectionName,
// //   collectionDocId,
// //   subCollectionName,
// //   subCollectionDocId,
// //   innerCollectionName,
// //   innerCollectionDocId,
// // }) => {
// //   return db
// //     .collection(collectionName)
// //     .doc(collectionDocId)
// //     .collection(subCollectionName)
// //     .doc(subCollectionDocId)
// //     .collection(innerCollectionName)
// //     .doc(innerCollectionDocId)
// //     .delete();
// // };

// export {
//   // createRes,
//   // generateUserDocument,
//   // userRegistration,
//   // getResource,
//   // userLogin,
//   // uploadImage,
//   // removeData,
//   // createResWithRefrence,
//   // getWithRefrence,
//   // userLogout,
//   // updateData,
//   // crerateNestedResource,
//   // getNestedCollectionWithRef,
//   // innerCollectionRefrence,
//   // updateNestedData,
//   // deleteNestedData,
//   // removeFiles,
//   // collectionGroupQuery,
//   // deleteResourceFromNestedSubCollection,
//   // getResourceFromIds,
//   writeUserData,
// };
